<div [ngStyle]="pointerStyle">
  <wl-card heading="Land Details">
    <app-spinner-overlay [showSpinner]="loading"></app-spinner-overlay>
    <!-- <md-progress-bar *ngIf="showWaitingLR" mode="buffer">
    Please wait - ದಯಮಾಡಿ ನಿರೀಕ್ಷಿಸಿ</md-progress-bar> -->
    <div class="row" *ngIf="showFetchButton">

      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 w-full text-center"
       >
        <button class="mt-2rem mybutton" [disabled]="isSubmitting || disableBcoz5landsAlready" (click)="fetchLandRecordsFruits()" >
          Fetch Land Records
          <!-- <br> ಭೂಮಿಯ ವಿವರಗಳನ್ನು ಪರಿಶೀಲಿಸಿ -->
        </button>
        <!-- [disabled]="
          detailsForm.controls['option'].invalid ||
          isFetchButtonDisabled
        " -->
        <!-- <img style="
              display: inline;
              height: 30px;
              margin-left: 5px;
              margin-bottom: -18px;
            " src="../../../assets/green-tick.png" *ngIf="showLandVerifiedTic" /> -->
      </div>
    </div>

    <br>

    <div class="w-50pct pl-25pct" *ngIf="SurveyNoWithVillage.length">
      <div class="row">
        <!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">

        <div>
          <p>
            Select Land details 
          </p>
        </div>
      </div> -->
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pr-10px display-grid"
         >


          <!-- <p class="font-size-1rem text-00569d">ಗಮನಿಸಿ: ಭೂಮಿಯ ವಿವರಗಳು ಅನುಕ್ರಮದಲ್ಲಿ ಲಭ್ಯವಿದೆ
          ಜಿಲ್ಲೆ-ತಾಲೂಕು-ಹೋಬಳಿ-ಗ್ರಾಮ-ಸರ್ವೆ ಸಂಖ್ಯೆ/ಸರ್ನೋಕ್/ಹಿಸ್ಸಾ ಸಂಖ್ಯೆ - ಎಕರೆ.ಗುಂಟೆ</p> -->

          <!-- <label *ngFor="let radiobutton of LandRecordArrayData; let indexOfelement=index;"
          class="mt-1rem">
          <input type="radio" name="option" (click)="model.option = radiobutton"
            (change)="handleSurveyOnChange(indexOfelement)" [checked]="(indexOfelement === checkIndex)"> {{
          radiobutton.DistrictName + "-" + radiobutton.TalukName + "-" + radiobutton.HobliName + "-" +
          radiobutton.VillageName + "-" + radiobutton.Surveyno + "/" + radiobutton.Surnoc + "/" +
          radiobutton.Hissano + " - Area " + radiobutton.ExtAcre + "." + radiobutton.ExtGunta}}
        </label> -->
          <mat-select placeholder="Select Land record and click verify" (selectionChange)="handleSurveyOnChange($event)">
            <mat-option *ngFor="let opt of SurveyNoWithVillage; let indexOfelement=index;"
              [value]="opt">{{opt.combinedName}}</mat-option>
          </mat-select>

          <p class="font-size-1rem text-00569d mt-20px">Note: The land details are available in the
            sequence of
            District-Taluk-Hobli-Village-Survey no/Surnoc/Hissa no - Acres.Guntas</p>
        </div>
      </div>


      <div class="row">

        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 w-full text-center"
         >
          <button class="mt-2rem mybutton" (click)="submitBhoomiDetailFruits()"
            [disabled]="isFetchButtonDisabled || disableBcoz5landsAlready">
            Verify
            <!-- <br> ಭೂಮಿಯ ವಿವರಗಳನ್ನು ಪರಿಶೀಲಿಸಿ -->
          </button>
          <!-- [disabled]="
          detailsForm.controls['option'].invalid ||
          isFetchButtonDisabled
        " -->
          <!-- <img style="
              display: inline;
              height: 30px;
              margin-left: 5px;
              margin-bottom: -18px;
            " src="../../../assets/green-tick.png" *ngIf="showLandVerifiedTic" /> -->
        </div>
      </div>
    </div>
  </wl-card>

  <div class="h-60vh" *ngIf="!noOfDocuments">
  </div>

  <!-- <wl-card hideNavbar="true" heading="Land Details" *ngIf="docPath"> -->
  <wl-card hideNavbar="true" heading="Land Details Output" *ngIf="noOfDocuments">

    <form novalidate [formGroup]="ownershipForm">

      <div formArrayName="bhoomi_details">
        <div *ngFor="let bhoomi_detail of bhoomi_details().controls; let i=index" [formGroupName]="i">
          <br>

          <div class="text-center">

          </div>
          <div class="container">
            <div class="row">
              <div class="col-12 col-md-4">
                <label></label>
              </div>
              <div class="col-12 col-md-4">
                <!-- <button *ngIf="docPath" (click)="downloadPdf(i)" class="h-18px mybutton"
                target="_blank">View
                Document - {{(noOfDocuments)-i}}</button> -->
              </div>
              <div class="col-12 col-md-2 text-right" *ngIf="showDelete">
                <!-- <i class="fa fa-trash-o deleteIcon" (click)="deleteRecord(i)"></i> -->
                <img class="deleteIcon h-30px" src="../../../../assets/fontawesome-web/svgs/regular/trash-can.svg"
                  (click)="deleteRecord(i)">
              </div>
            </div>
          </div>

          <br>
          <wl-input type="text" label="Name(as per KYC from CBS)" placeholder="Name" formControlName="name_as_per_bhumi"
            class="form-control" [readonly]=true></wl-input>
          <wl-input type="text" label="Land Area (in Acres, to be filled by RDO)" placeholder="Land Area(in Acre)"
            formControlName="land_area" class="form-control" [readonly]="readOnlyArray[i]"></wl-input>
          <wl-input type="text" label="Land Ownership (as per Bhumi report, to be filled by RDO)"
            placeholder="Land Ownership" formControlName="land_ownership" class="form-control"
            [readonly]="readOnlyArray[i]"></wl-input>
          <wl-input *ngIf="showInput" type="text" label="Charge Details (as per Bhumi report, to be filled by RDO)"
            placeholder="Charge Details" formControlName="charge_details" class="form-control"
            [readonly]="readOnlyArray[i]"></wl-input>
          <!-- <wl-input type="text" label="Land Value (To be filled by RDO)"
          placeholder="Land Value" formControlName="land_value" class="form-control">((noOfDocuments)-i-1)</wl-input> -->
          <div class="text-center display-none">
            <br>
            <button class="mybutton" (click)="submitBhoomiDetail(((noOfDocuments)-i-1));bhoomiForm.reset()"
              [disabled]="readOnlyArray[i]">Submit</button>
          </div>

          <div class="h-1px bg-e4e4e4 mt-32px mb-10px"></div>
        </div>
      </div>

      <div class="text-center">
        <button class="mybutton" (click)="submitLandRecords()" [disabled]="disableSubmitLandRecords || hideSubmitButton">Submit</button>
        <!-- <button class="mybutton" (click)="submitLandRecords()" >Submit Land Records</button> -->
      </div>
    </form>

  </wl-card>

</div>